export default "__VITE_ASSET__30822543__"